<template>
    <div class="g-sidebar__container">
        <h3 class="g-sidebar__container__header">
          <LifeRingIcon
            height="22"
            width="22"
          />
          <span>{{ $t('dashboard.support')}}</span>
        </h3>
        <i18n path="help.sidebarMessage.a" tag="p">
          <template v-slot:link>
            <RouterLink
              data-ec="help_widget"
              data-et="link_to_help_page"
              to="/help"
            >
              {{ $t('help.sidebarMessage.aLink') }}
            </RouterLink>
          </template>
        </i18n>
        <p>{{ $t('help.sidebarMessage.b') }}</p>
    </div>
</template>

<script>
import { LifeRingIcon } from '@/components/icons/fontIcons';

export default {
  name: 'HelpAndSupportWidget',
  components: {
    LifeRingIcon,
  },
};
</script>
